module.exports = __webpack_public_path__ + "img/huaxia.9791536c.jpg";